import React from "react";
import { motion } from "framer-motion";
import ScrollReveal from "./ScrollReveal";

// === Slider Partners (Updated based on uploaded image data) ===
const sliderPartners = [
  // {
  //   name: "Zscaler",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/2/29/Zscaler_logo.png",
  // },
  {
    name: "Netskope",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/netscope_ngqtlr.avif",
  },
  {
    name: " Cato Networks",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/cato_k6byr3.png",
  },
  {
    name: " Menlo Security",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772882987/Screenshot_2026-03-07_165915_nqndwj.png",
  },

  {
    name: "Varonis",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/Varonis-Logo_381x275_xq5wz5.png",
  },

  {
    name: "Cyera",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772890856/Screenshot_2026-03-07_191019_lx3kiv.png",
  },
  // {
  //   name: "BigID",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772890987/BigID-next-1_mw5nco.png",
  // },
  {
    name: "CrowdStrike",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/crowdstrike_fbisbj.avif",
  },

  // {
  //   name: "sentinelOne",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891298/header-logo-dark_wkcwyr.svg",
  // },

  {
    name: "CyberArk",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891367/cyberark-logo-tagline_s8qu88.svg",
  },
  // {
  //   name: "SailPoint",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891462/SailPoint-logo-cropped_ixetqw.svg",
  // },
  {
    name: "saviynt",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891522/saviynt-logo-DWEmNKg8_e5nmpn.svg",
  },
  {
    name: "proofpoint",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772891642/header-nav__logo_lckun2.svg",
  },
  {
    name: "Abnormal Security",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/abnormal-logo-png_seeklogo-442229_c4zwti.png",
  },
  // {
  //   name: "Mimecast",
  //   logo: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/68808230283150624a88d443_mimecast.svgg",
  // },
  //newly added from slider
  {
    name: "Datadog",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1783241811/datadogs_vpm593.avif",
  },
  {
    name: "Dynatrace",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/dynatrace_web_logo_mteouk.png",
  },
  {
    name: "Operant",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773052412/operant_fh5odi.svg",
  },
  {
    name: "Lakera",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/lakera_apskuj.png",
  },

  {
    name: "Wiz",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773052412/wiz_wg40wv.png",
  },
  {
    name: "veeam",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773052412/veeam_di40mp.png",
  },
  // {
  //   name: "Cranium",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773123731/cranium_ai_cpa824.png",
  // },
  {
    name: "holisticAI",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773123824/hoslistic_msjudy.png",
  },
  // {
  //   name: "OneTrust",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773123972/One_truatT-website-logo_dkdtmg.svg",
  // },
  // {
  //   name: "credoAI",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124078/credo_taqfhj.png",
  // },
  // {
  //   name: "Palo Alto Networks",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124092/palo_alto_gtdg10.png",
  // },
  // {
  //   name: "securiti.ai",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124229/securitiii2026-03-10_115944_i4tgn2.png",
  // },
  // {
  //   name: "Microsoft Security",
  //   logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1773124240/micros_t0wbzz.png",
  // },
  {
    name: "zenity",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179263/Zenity-Logo_jywy90.png",
  },
  {
    name: "Pentera",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776352940/pentera-logo-black_rzwqt8.svg",
  },

  // {
  //   name: "CrowdStrike",
  //   logo: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6854f6bebf621c10d29dc8b0_3%20Crowdstrike.aviff",
  // },
  // {
  //   name: "Google Cloud",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg",
  // },
  // {
  //   name: "Netskope",
  //   logo: "https://www.netskope.com/wp-content/uploads/2019/02/netskope-logo.png",
  // },
  // {
  //   name: "Okta",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/8/83/Okta_logo_%282023%29.svg",
  // },
  // {
  //   name: "AWS",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
  // },
  // {
  //   name: "Google Workspace",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Google_Workspace_Logo.svg",
  // },
  // {
  //   name: "NinjaOne",
  //   logo: "https://www.ninjaone.com/wp-content/uploads/2021/08/NinjaOne_Logo_Primary_Color-1.svg",
  // },
  {
    name: "Vanta",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776352939/vanta-logo_uljhws.svg",
  },
  {
    name: "Connectwise",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776352939/connectbg-cw-black_igvnag.webp",
  },
  // {
  //   name: "Akamai",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/8/8b/Akamai_logo.svg",
  // },
  // {
  //   name: "CTM360",
  //   logo: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6854f6c4ecfbd1277c019a72_4%20CRM360%201.aviff",
  // },
  // {
  //   name: "Kissflow",
  //   logo: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6854f6d9a28f3b57f44148d6_7%20Kissflow.aviff",
  // },
  // {
  //   name: "Datadog",
  //   logo: "https://cdn.prod.website-files.com/65b8bf4128bf6ef762cf3954/6854f6ca774dd90859ee0a4d_5%20Datadog.aviff",
  // },
  //
  // {
  //   name: "Rubrik",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/9/9b/Rubrik_Logo.svg",
  // },
  // {
  //   name: "ExtraHop",
  //   logo: "https://mma.prnewswire.com/media/1997361/ExtraHop_Networks_Logo.jpg?p=facebook",
  // },
  // {
  //   name: "Pentera",
  //   logo: "https://upload.wikimedia.org/wikipedia/commons/e/ea/Pentera_wide_color.png",
  // },
  {
    name: "Akamai Guardicore",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1777958225/akamai-logo-v5_y6r5yy.svg",
  },
  {
    name: "Group IB",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1781706273/Group-IB_logo_ecdxu6.png",
  },

  {
    name: "Vectra AI",
    logo: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1779179262/vectra-ai-platform_xpojll.png",
  },
];

const Partners = () => {
  return (
    <div className="relative overflow-hidden bg-white text-slate-900 w-full">
      {/* === Inject Custom Keyframes for Twin Marquee === */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          animation: marquee 50s linear infinite;
        }
        .group:hover .animate-marquee {
          animation-play-state: paused;
        }
      `}</style>

      {/* === Background Gradients === */}
      <motion.div
        className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-100/40 rounded-full blur-3xl -z-10"
        animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
        transition={{ duration: 8, repeat: Infinity }}
      />
      <motion.div
        className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-indigo-100/40 rounded-full blur-3xl -z-10"
        animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
        transition={{ duration: 10, repeat: Infinity }}
      />

      {/* === Hero Section === */}
      <ScrollReveal>
        <section className="relative flex flex-col items-center justify-center text-center pt-24 pb-12 px-4">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-green-600 font-bold tracking-[0.2em] uppercase text-xl mb-6"
          >
            Partners
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 leading-[1.1]"
          >
            Industry-leading experience.
            <br className="hidden md:block" />{" "}
            <span className="md:mt-2 block">World-class partners.</span>
          </motion.h1>
        </section>

        {/* === SEAMLESS INFINITE SLIDER === */}
        <section className="py-10 pb-24 relative bg-white overflow-hidden">
          {/* Gradient Masks (Fade Effect on Edges) */}
          <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

          {/* Marquee Container */}
          <div className="flex overflow-hidden group w-full">
            {/* GROUP 1 */}
            <div className="flex items-center gap-10 pr-10 animate-marquee shrink-0 min-w-full">
              {sliderPartners.map((partner, index) => (
                <img
                  key={`g1-${index}`}
                  src={partner.logo}
                  alt={partner.name}
                  loading="lazy"
                  className="h-8 sm:h-10 md:h-12 w-auto object-contain flex-shrink-0 cursor-pointer transition-transform hover:scale-105"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ))}
            </div>

            {/* GROUP 2 (Clone for infinite loop) */}
            <div
              className="flex items-center gap-10 pr-10 animate-marquee shrink-0 min-w-full"
              aria-hidden="true"
            >
              {sliderPartners.map((partner, index) => (
                <img
                  key={`g2-${index}`}
                  src={partner.logo}
                  alt={partner.name}
                  loading="lazy"
                  className="h-8 sm:h-10 md:h-12 w-auto object-contain flex-shrink-0 cursor-pointer transition-transform hover:scale-105"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ))}
            </div>
          </div>
        </section>
      </ScrollReveal>
    </div>
  );
};

export default Partners;
